import React from "react";

import {
  Box,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";

import {
  ArrowClockwiseIcon,
  PaperPlaneTiltIcon,
  PencilSimpleLineIcon,
  TrashIcon,
} from "@phosphor-icons/react/dist/ssr";

import SquareChip from "@/components/elements/Chips/SquareChip";
import type { Example } from "@/types";
import { htmlContentStyles } from "@/utils/htmlContentStyle";
import { renderMathInHtml } from "@/utils/mathRenderer";

interface ViewExampleProps {
  example: Example;
  onApprove?: () => void;
  onEdit?: () => void;
  onRegenerate?: () => void;
  onDelete?: () => void;
}

const ViewExample: React.FC<ViewExampleProps> = ({
  example,
  onApprove,
  onEdit,
  onRegenerate,
  onDelete,
}) => (
  <>
    <DialogContent
      dividers
      sx={{
        borderTop: "none",
        borderBottom: "none",
      }}
    >
      <Box sx={{ mb: 2 }}>
        <SquareChip
          label={example.concept}
          sx={{
            mb: 1,
          }}
        />
      </Box>
      <Typography
        component="div"
        variant="text13L"
        sx={{
          ...htmlContentStyles,
          fontSize: "13px",
        }}
        dangerouslySetInnerHTML={{
          __html: renderMathInHtml(example.description),
        }}
      />
    </DialogContent>
    {!example?.isApproved && (onApprove || onEdit || onRegenerate || onDelete) && (
      <DialogActions
        sx={{
          justifyContent: "flex-end",
          gap: 0.75,

        }}
      >
        {onApprove && (
          <IconButton
            onClick={onApprove}
            size="small"
            sx={{
              p: 0.5,
              color: "primary.main",
              "&:hover": {
                backgroundColor: "rgba(235, 94, 42, 0.1)",
              },
            }}
          >
            <PaperPlaneTiltIcon size={16} weight="bold" />
          </IconButton>
        )}
        {onEdit && (
          <IconButton
            onClick={onEdit}
            size="small"
            sx={{
              p: 0.5,
              color: "text.primary",
              "&:hover": {
                backgroundColor: "rgba(28, 72, 46, 0.08)",
              },
            }}
          >
            <PencilSimpleLineIcon size={16} weight="bold" />
          </IconButton>
        )}
        {onRegenerate && (
          <IconButton
            onClick={onRegenerate}
            size="small"
            sx={{
              p: 0.5,
              color: "text.primary",
              "&:hover": {
                backgroundColor: "rgba(28, 72, 46, 0.08)",
              },
            }}
          >
            <ArrowClockwiseIcon size={16} weight="bold" />
          </IconButton>
        )}
        {onDelete && (
          <IconButton
            onClick={onDelete}
            size="small"
            sx={{
              p: 0.5,
              color: "error.main",
              "&:hover": {
                backgroundColor: "rgba(240, 82, 82, 0.1)",
              },
            }}
          >
            <TrashIcon size={16} weight="bold" />
          </IconButton>
        )}
      </DialogActions>
    )}
  </>
);

export default ViewExample;
